import { Component, Host, OnDestroy, Input, Output, HostListener } from '@angular/core';
import { DropdownSelectButtonComponent } from '../dropdown-select-button.component';

@Component({
    selector: 'dropdown-select-item',
    templateUrl: './dropdown-select-item.component.html',
    styleUrls: ['./dropdown-select-item.component.scss'],
    host: {
        style: 'width:120px; background-color:white;',
        tabindex: '0'
    },
    standalone: false
})
export class DropdownSelectItemComponent implements OnDestroy {
    @Input()
    value: any;
    @Output()
    selected: boolean = false;
    @HostListener('focusout', ['$event'])
    focusOut(event: MouseEvent) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
    }

    constructor(
        @Host() public _dropdown: DropdownSelectButtonComponent
    ) {
        this._dropdown.items.push(this);
   
    }

    ngOnDestroy() {
        this._dropdown.items.splice(this._dropdown.items.findIndex(x => x === this), 1);
    }

    click(event: MouseEvent): void {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        this._dropdown.setSelected(this);
        this._dropdown.toggleMenu(null);
    }
}
